import { render } from "./BatchLoaderModalCsv.vue?vue&type=template&id=389c3bb0&ts=true"
import script from "./BatchLoaderModalCsv.vue?vue&type=script&lang=ts"
export * from "./BatchLoaderModalCsv.vue?vue&type=script&lang=ts"

import "./BatchLoaderModalCsv.vue?vue&type=style&index=0&id=389c3bb0&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__